<div class="modal-body">
    <div class="crud">
        <h3 class="crud__title" *ngIf="!hideTitle">{{ entry?.created_at | dateFormat : 'dateTime' }}</h3>
        <cm-dynamic-form
            #dynamicForm
            [elements]="entry.fields"
            [sections]="entry.sections"
            [disabled]="formDisabled"
            [showErrors]="false"
            [displayMessages]="true"
        ></cm-dynamic-form>
        <cm-signature
            *ngIf="entry.signature_link"
            [editable]="!formDisabled"
            [introTmpl]="introSignature"
            class="signature-bar"
        ></cm-signature>
        <div class="errors-container" [ngClass]="{ 'show-errors': !!signatureError }">{{ signatureError }}</div>
    </div>
</div>
<div class="modal-footer" *ngIf="!hideButtons">
    <ng-container *ngIf="mode === modes.READ">
        <button type="button" class="btn btn-default" (click)="back()">BACK</button>
        <button
            type="button"
            [disabled]="step._userActionsDisabled"
            *ngIf="stepEditableStatus"
            class="btn btn-default"
            (click)="remove()"
        >
            REMOVE ENTRY
        </button>
        <button
            type="button"
            [disabled]="step._userActionsDisabled"
            *ngIf="stepEditableStatus"
            class="btn btn-primary"
            (click)="onEdit()"
        >
            EDIT ENTRY
        </button>
    </ng-container>
    <ng-container *ngIf="mode === modes.EDIT">
        <button type="button" class="btn btn-default" (click)="onCancelEdit()">CANCEL</button>
        <button type="button" class="btn btn-primary" *ngIf="step.content.allowMultipleEntries" (click)="save(true)">
            Save as draft
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">SAVE</button>
    </ng-container>
</div>
